import { Form, Formik, FormikHelpers } from 'formik';
import { useAuthClaims } from '../../hooks/useAuthClaims';
import styles from './GroupForm.module.scss';
import { GroupFormProfiles } from './GroupFormProfiles';
import { ModalBottomButtons } from '../ModalBottomButtons/ModalBottomButtons';
import { graphql } from 'client/gql';
import { useMutation, useQuery } from 'urql';
import { GroupType } from 'client/gql/graphql';
import { showErrorToast, showSuccessSaveToast } from 'utils/toasts';

const UpdateGroupsMutationDocument = graphql(`
  mutation BpUpdateGroupsInGroupFormOther($update: BpGroupUpdateInput!, $uuid: ID!) {
    updateBpGroup(update: $update, uuid: $uuid) {
      uuid
      __typename
      viewers {
        uuid
        __typename
      }
      editors {
        uuid
        __typename
      }
    }
  }
`);

const GroupFormOtherPageQueryDocument = graphql(`
  query GroupFormOtherPageData($groupUuid: ID!, $organizationUuid: ID!, $groupType: GroupType!) {
    groups(where: { uuid: $groupUuid }) {
      uuid
      __typename
      editors {
        uuid
        __typename
      }
      viewers {
        uuid
        __typename
      }
    }
    ...GroupFormProfilesFields
  }
`);

export type GroupFormOtherValues = {
  viewers: string[];
  editors: string[];
  classes?: string[] | null | undefined;
};

interface GroupsFormOtherProps {
  groupUuid: string;
  onLoad?: (loading: boolean) => void; // TODO: make mandatory and refactor
  onClose: () => void;
}

export const GroupFormOther = ({ groupUuid, onLoad, onClose }: GroupsFormOtherProps) => {
  const { pimAuthClaims } = useAuthClaims();
  const organizationUuid = pimAuthClaims.getOrganizationUuid();

  const [{ data }] = useQuery({
    query: GroupFormOtherPageQueryDocument,
    variables: { groupUuid: groupUuid, organizationUuid, groupType: GroupType.Group },
  });

  const [, bpUpdateGroup] = useMutation(UpdateGroupsMutationDocument);

  const currentGroup = data?.groups[0];

  const handleSubmit = async (values: GroupFormOtherValues, formHelpers: FormikHelpers<GroupFormOtherValues>) => {
    onLoad && onLoad(true);

    const { viewers, editors } = values;

    const { error } = await bpUpdateGroup({
      update: {
        viewers: viewers.filter((v) => !currentGroup?.editors.map((e) => e.uuid).includes(v)),
        editors, // : currentGroup?.editors.map((e) => e.uuid) ?? [],
      },
      uuid: groupUuid,
    });

    error ? showErrorToast(error.message) : showSuccessSaveToast();

    onLoad && onLoad(false);
    formHelpers.resetForm();
    onClose();
  };

  //TODO do it properly. For now lets add editors to the same array...
  const initialValue: GroupFormOtherValues = {
    viewers: currentGroup ? currentGroup.viewers.map((value) => value.uuid) : [],
    editors: currentGroup ? currentGroup.editors.map((value) => value.uuid) : [],
  };

  return (
    <Formik<GroupFormOtherValues> onSubmit={handleSubmit} initialValues={initialValue}>
      {({ errors, isSubmitting }) => {
        return (
          <Form className={styles['group-form']}>
            <GroupFormProfiles query={data} />
            <ModalBottomButtons closeButton={{ callback: onClose }} isLoading={isSubmitting} errors={errors} />
          </Form>
        );
      }}
    </Formik>
  );
};
